/**
 * Language switcher. Shows the current locale as a 2-letter code (ID / EN)
 * with a flag emoji prefix; click opens a small menu to switch.
 *
 * Persistence is handled by LocaleProvider (writes to localStorage on every
 * change), so the selection survives reloads. The page does NOT need to
 * reload — every component that uses `useTranslation` re-renders when the
 * context value changes.
 */
import { ActionIcon, Menu, Tooltip } from '@mantine/core';
import { IconLanguage } from '@tabler/icons-react';
import { useTranslation } from '../i18n/LocaleContext';

export function LocaleSwitcher() {
  const { locale, setLocale, t } = useTranslation();

  return (
    <Menu position="bottom-end" withArrow shadow="md">
      <Menu.Target>
        <Tooltip label={t('locale.label')} withArrow>
          <ActionIcon variant="default" size="lg" radius="md" aria-label={t('locale.label')}>
            <IconLanguage size={18} />
          </ActionIcon>
        </Tooltip>
      </Menu.Target>
      <Menu.Dropdown>
        <Menu.Label>{t('locale.label')}</Menu.Label>
        <Menu.Item
          onClick={() => setLocale('id')}
          rightSection={locale === 'id' ? '✓' : null}
        >
          🇮🇩 {t('locale.indonesian')}
        </Menu.Item>
        <Menu.Item
          onClick={() => setLocale('en')}
          rightSection={locale === 'en' ? '✓' : null}
        >
          🇬🇧 {t('locale.english')}
        </Menu.Item>
      </Menu.Dropdown>
    </Menu>
  );
}
